class CustomCardsSlider extends HTMLElement {
  constructor() {
    super();
    const slider = this;
    var flkty = new Flickity( slider, {
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'center'
    });
  }
}

customElements.define('custom-cards-slider', CustomCardsSlider);

